// extracted by mini-css-extract-plugin
export default {"CenterLoader":"CenterLoader__CenterLoader--zwjrC"};